import { Divider, Typography, Upload } from 'antd'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  addQuestion,
  markForEdit,
  removeQuestion,
  replaceQuestion
} from '../../../reducers/assessmentCreationReducer'
import QuestionList from './QuestionList'
import { InboxOutlined } from '@ant-design/icons'
import { useParams } from 'react-router'

const { Dragger } = Upload
const { Title, Text } = Typography

const AssessmentQuestionsSection = (props) => {
  const dispatch = useDispatch()
  const [titleError, setTitleError] = useState('')

  const {
    title,
    setTitle,
    questions,
    controlledQuestionType,
    files,
    setFiles
  } = props

  const createQuestion = () => {
    dispatch(addQuestion())
  }
  const updateQuestion = (question) => {
    dispatch(replaceQuestion(question))
  }
  const deleteQuestion = (question) => {
    dispatch(removeQuestion(question))
  }
  const draftQuestion = (question) => {
    dispatch(markForEdit(question))
  }

  const handleFileRemove = (removedFile) => {
    setFiles(files.filter((file) => file.uid !== removedFile.uid))
  }

  const handleFileSubmit = ({ file, onSuccess, onError }) => {
    if (!title || title.trim() === '') {
      setTitleError('Title is required before uploading files')
      onError(new Error('Title is missing'))
      return
    }
    setTitleError('')

    const fileToStore = {
      ...file,
      status: 'done'
    }

    setFiles((prevFiles) => prevFiles.concat([fileToStore]))

    onSuccess()
  }

  return (
    <div
      style={{
        backgroundColor: '#fafafa',
        width: '95%',
        margin: '0 auto',
        borderRadius: '10px',
        padding: '20px 20px'
      }}
    >
      <Title
        editable={{
          onChange: (val) => {
            setTitle(val)
            if (!val || val.trim() === '') {
              setTitleError('Title is required')
            } else if (val.length > 30) {
              setTitleError('Title cannot exceed 25 characters')
            } else {
              setTitleError('')
            }
          }
        }}
        level={3}
      >
        {title}
      </Title>

      {titleError && <Text type="danger">{titleError}</Text>}

      <Divider />

      {controlledQuestionType === 'online' && (
        <QuestionList
          questions={questions}
          updateQuestion={updateQuestion}
          deleteQuestion={deleteQuestion}
          draftQuestion={draftQuestion}
          createQuestion={createQuestion}
        />
      )}

      {controlledQuestionType === 'file' && (
        <Dragger
          onChange={(info) => {
            setFiles(info.fileList)
          }}
          customRequest={handleFileSubmit}
          onRemove={handleFileRemove}
          fileList={files}
          beforeUpload={() => false}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
        </Dragger>
      )}
    </div>
  )
}

export default AssessmentQuestionsSection
